(function () {
  if (window.__tp) return; window.__tp = 1;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Copy offer code (product story + buy box)
  document.querySelectorAll('[data-tp-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var code = b.getAttribute('data-tp-copy');
      var label = b.querySelector('[data-tp-copied]');
      var done = function () { if (label) { label.textContent = 'Copied'; setTimeout(function () { label.textContent = 'Copy'; }, 1800); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
    });
  });

  var root = document.querySelector('.tp');
  if (!root) return;

  var inView = function (el, cb, th) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting); }); }, { threshold: th || 0.2 }).observe(el);
  };

  // Before / after sliders
  root.querySelectorAll('[data-tp-ba], [data-tp-water]').forEach(function (box) {
    var range = box.querySelector('.tp-ba__range');
    var set = function (v) { box.style.setProperty('--p', v + '%'); box._p = v / 100; };
    set(50);
    range.addEventListener('input', function () { set(range.value); box._touched = true; });
    // a gentle sweep the first time it scrolls into view, to show it can be dragged
    var shown = false;
    inView(box, function (on) {
      if (!on || shown || reduce) return; shown = true;
      var t0 = null;
      var step = function (ts) {
        if (box._touched) return;
        if (!t0) t0 = ts;
        var k = (ts - t0) / 2200; if (k > 1) k = 1;
        var v = 50 + Math.sin(k * Math.PI * 2) * 28 * (1 - k);
        set(v); range.value = v;
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }, 0.5);
  });

  // Water illustration canvas
  var wbox = root.querySelector('[data-tp-water]');
  if (wbox) {
    var cv = wbox.querySelector('canvas'), cx = cv.getContext('2d');
    var W, H, dpr = Math.min(window.devicePixelRatio || 1, 1.5), parts = [], bubs = [], running = false;
    var size = function () { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; cx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    var seed = function () {
      parts = []; bubs = [];
      var n = Math.round(W * H / 2600);
      for (var i = 0; i < n; i++) parts.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 2.4 + .6, vx: (Math.random() - .5) * .25, vy: (Math.random() - .5) * .2, c: Math.random() < .55 ? 'rgba(150,130,90,' : 'rgba(120,140,130,', a: Math.random() * .4 + .25 });
      for (var j = 0; j < 26; j++) bubs.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 5 + 2, s: Math.random() * .5 + .25 });
    };
    var draw = function (t) {
      var split = W * (wbox._p == null ? .5 : wbox._p);
      // tap side: hazy, warm
      var g1 = cx.createLinearGradient(0, 0, 0, H); g1.addColorStop(0, '#E9E4D6'); g1.addColorStop(1, '#D9D2BE');
      cx.fillStyle = g1; cx.fillRect(0, 0, split, H);
      // filtered side: clear aqua light
      var g2 = cx.createLinearGradient(0, 0, 0, H); g2.addColorStop(0, '#F4FBF8'); g2.addColorStop(1, '#DCEDE8');
      cx.fillStyle = g2; cx.fillRect(split, 0, W - split, H);
      // caustic light on filtered side
      cx.save(); cx.beginPath(); cx.rect(split, 0, W - split, H); cx.clip();
      cx.globalAlpha = .5; cx.strokeStyle = 'rgba(255,255,255,.9)'; cx.lineWidth = 1.5;
      for (var k = 0; k < 7; k++) {
        cx.beginPath();
        for (var x = split; x <= W; x += 14) {
          var y = H * (k + .5) / 7 + Math.sin(x * .018 + t * .0012 + k) * 12 + Math.sin(x * .007 - t * .0008 + k * 2) * 18;
          if (x === split) cx.moveTo(x, y); else cx.lineTo(x, y);
        }
        cx.stroke();
      }
      cx.globalAlpha = 1;
      bubs.forEach(function (b) {
        b.y -= b.s; if (b.y < -10) { b.y = H + 10; b.x = Math.random() * W; }
        var bx = b.x + Math.sin(t * .002 + b.r) * 3;
        if (bx < split) return;
        cx.beginPath(); cx.arc(bx, b.y, b.r, 0, 6.283); cx.strokeStyle = 'rgba(156,118,51,.35)'; cx.lineWidth = 1; cx.stroke();
        cx.beginPath(); cx.arc(bx - b.r * .35, b.y - b.r * .35, b.r * .3, 0, 6.283); cx.fillStyle = 'rgba(255,255,255,.9)'; cx.fill();
      });
      cx.restore();
      // particles on tap side
      cx.save(); cx.beginPath(); cx.rect(0, 0, split, H); cx.clip();
      parts.forEach(function (p) {
        p.x += p.vx + Math.sin(t * .001 + p.y * .02) * .15; p.y += p.vy;
        if (p.x < 0) p.x = W; if (p.x > W) p.x = 0; if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
        if (p.x > split) return;
        cx.beginPath(); cx.arc(p.x, p.y, p.r, 0, 6.283); cx.fillStyle = p.c + p.a + ')'; cx.fill();
      });
      cx.restore();
    };
    var loop = function (t) { if (!running) return; draw(t); requestAnimationFrame(loop); };
    size(); seed(); draw(0);
    window.addEventListener('resize', function () { size(); seed(); draw(0); });
    inView(wbox, function (on) { if (reduce) { draw(0); return; } if (on && !running) { running = true; requestAnimationFrame(loop); } else if (!on) running = false; }, 0.05);
    wbox.querySelector('.tp-ba__range').addEventListener('input', function () { if (!running) draw(0); });
  }

  // Anatomy hotspots
  var anat = root.querySelector('[data-tp-anat]');
  if (anat) {
    var hots = anat.querySelectorAll('.tp-hot'), items = root.querySelectorAll('.tp-anat__list li');
    var pick = function (i) {
      hots.forEach(function (h, k) { h.classList.toggle('is-on', k === i); });
      items.forEach(function (li, k) { li.classList.toggle('is-on', k === i); });
    };
    hots.forEach(function (h, i) { h.addEventListener('click', function () { pick(i); anat._t && clearInterval(anat._t); }); });
    items.forEach(function (li, i) { li.addEventListener('click', function () { pick(i); anat._t && clearInterval(anat._t); }); });
    pick(0);
    if (!reduce) { var cur = 0; inView(anat, function (on) { if (on && !anat._t) anat._t = setInterval(function () { cur = (cur + 1) % hots.length; pick(cur); }, 3200); }); }
  }

  // Spray modes canvas
  var sv = root.querySelector('.tp-spray__cv');
  if (sv) {
    var sx = sv.getContext('2d'), mode = 0, drops = [], sW, sH, sr = Math.min(window.devicePixelRatio || 1, 1.5), sRun = false;
    var label = root.querySelector('[data-tp-mode-label]');
    var names = ['Rainfall', 'Massage', 'Mixed'];
    var ssize = function () { sW = sv.clientWidth; sH = sv.clientHeight; sv.width = sW * sr; sv.height = sH * sr; sx.setTransform(sr, 0, 0, sr, 0, 0); };
    var spawn = function () {
      var cxp = sW / 2, top = sH * .2, R = Math.min(sW, sH) * .2;
      var m = mode === 2 ? (Math.random() < .5 ? 0 : 1) : mode;
      var a = Math.random() * 6.283, rr = m === 0 ? Math.sqrt(Math.random()) * R : Math.sqrt(Math.random()) * R * .35;
      var spread = m === 0 ? 1.15 : 0.25;
      drops.push({ x: cxp + Math.cos(a) * rr, y: top + 6, vx: Math.cos(a) * rr / R * spread, vy: m === 0 ? 2.2 + Math.random() : 4.2 + Math.random() * 1.5, w: m === 0 ? 1.1 : 2.2, l: m === 0 ? 8 : 16 });
    };
    var sdraw = function () {
      sx.clearRect(0, 0, sW, sH);
      var cxp = sW / 2, top = sH * .2, R = Math.min(sW, sH) * .2;
      var rate = mode === 0 ? 7 : mode === 1 ? 5 : 8;
      for (var i = 0; i < rate; i++) spawn();
      sx.strokeStyle = 'rgba(110,165,172,.75)'; sx.lineCap = 'round';
      drops = drops.filter(function (d) {
        d.x += d.vx; d.y += d.vy; d.vy += .06;
        sx.lineWidth = d.w; sx.beginPath(); sx.moveTo(d.x, d.y); sx.lineTo(d.x - d.vx * 2, d.y - d.l); sx.stroke();
        return d.y < sH + 20;
      });
      // shower face
      sx.beginPath(); sx.ellipse(cxp, top, R * 1.12, R * .32, 0, 0, 6.283); sx.fillStyle = '#C9A96A'; sx.fill();
      sx.beginPath(); sx.ellipse(cxp, top, R, R * .27, 0, 0, 6.283); sx.fillStyle = '#F2F2EF'; sx.fill();
      sx.fillStyle = 'rgba(120,110,90,.35)';
      for (var k = 0; k < 40; k++) { var a = k * 2.4, rr = Math.sqrt(k / 40) * R * .9; sx.fillRect(cxp + Math.cos(a) * rr, top + Math.sin(a) * rr * .27, 1.6, 1.6); }
    };
    var sloop = function () { if (!sRun) return; sdraw(); requestAnimationFrame(sloop); };
    ssize(); sdraw();
    window.addEventListener('resize', ssize);
    root.querySelectorAll('.tp-modes button').forEach(function (b) {
      b.addEventListener('click', function () {
        mode = +b.getAttribute('data-mode');
        root.querySelectorAll('.tp-modes button').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        if (label) label.textContent = names[mode];
        if (!sRun) { drops = []; for (var i = 0; i < 40; i++) sdraw(); }
      });
    });
    inView(sv, function (on) { if (reduce) { for (var i = 0; i < 60; i++) sdraw(); return; } if (on && !sRun) { sRun = true; requestAnimationFrame(sloop); } else if (!on) sRun = false; }, 0.05);
  }

  // Cost per shower
  var vi = root.querySelector('[data-tp-i]');
  if (vi) {
    var base = +root.getAttribute('data-base') || 4800, refill = +root.getAttribute('data-refill') || 1190;
    var o = root.querySelector('[data-tp-o]'), p1 = root.querySelector('[data-tp-ps1]'), p2 = root.querySelector('[data-tp-ps2]'), yr = root.querySelector('[data-tp-yr]');
    var calc = function () {
      var n = +vi.value, quarter = n * 13;
      o.textContent = n;
      p1.textContent = Math.max(1, Math.round(base / quarter));
      p2.textContent = Math.max(1, Math.round(refill / quarter));
      yr.textContent = (n * 52).toLocaleString('en-GB');
      vi.style.setProperty('--p', ((n - 2) / 19 * 100) + '%');
    };
    vi.addEventListener('input', calc); calc();
  }

  // Unfiltered showers so far this year (EST average 5.4 a week)
  var unf = root.querySelector('[data-tp-unf]');
  if (unf) {
    var now = new Date(), start = new Date(now.getFullYear(), 0, 1);
    var days = (now - start) / 864e5, target = Math.round(days * 5.4 / 7);
    var shownU = false;
    inView(unf, function (on) {
      if (!on || shownU) return; shownU = true;
      if (reduce) { unf.textContent = target; return; }
      var t0 = null;
      var tick = function (ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / 1600); unf.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    });
  }

  // "Choose your bundle" scrolls back to the buy box
  root.querySelectorAll('[data-tp-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var form = document.querySelector('product-form, form[action*="/cart/add"], .product-info');
      if (form) { e.preventDefault(); form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
    });
  });
})();
